import axios, { AxiosError } from 'axios'

export function isAxiosError(payload?: unknown): payload is AxiosError {
  const result = (payload as AxiosError)?.isAxiosError === true || axios.isCancel(payload)
  return result
}
